import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { ECustomPropertyType, IBoardCardCustomOption } from '../../../../../../../../../store/customProperties/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import {
    getProFeaturesTrialActive
} from '../../../../../../../../../store/model/authUser/selectors/getProFeaturesTrialActive';
import {
    authUserSetUsedProFeatures
} from '../../../../../../../../../rest/effects/authUser/authUserSetUsedProFeatures';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    segmentTrackAction
} from '../../../../../../../../../middlewares/segment';
import { SegmentCardSourceValue } from '../../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { addProperty } from '../effects/addProperty';

export const onAdd = (
    boardId: TBoardId,
    name: string,
    type: ECustomPropertyType,
    options: IBoardCardCustomOption[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (getProFeaturesTrialActive(getState())) {
            dispatch(authUserSetUsedProFeatures('allowCardCustomProperties'));
        }
        dispatch(segmentTrackAction(SegmentCardEvent.CUSTOM_PROPERTY_ADDED, {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardSourceValue.BOARD_SETTINGS
        }, [{
            name: SegmentCardOptions.TYPE,
            value: type
        }]));
        return dispatch(addProperty(boardId, name, type, options && options.filter(item => item.value)));
    };
    return action;
};
